import React, { useEffect, useState } from "react";
import {
  Box,
  Modal,
  Typography,
  Checkbox,
  FormControlLabel,
  Button,
  Grid,
  Divider,
} from "@mui/material";
import axios from "axios";

export default function EvaluationModal({ open, handleClose }) {
  const [evaluationData, setEvaluationData] = useState([]);
  const [selectedNotes, setSelectedNotes] = useState([]);

  useEffect(() => {
    console.log("Fetching Evaluation Data...");

    const userData = JSON.parse(localStorage.getItem("userData"));
    if (!userData || !userData.Data) {
      console.error("No user data found in localStorage.");
      return;
    }

    axios
      .get("https://tarabotcs.com-eg.net/api/Admins/V1/GetEvalItems", {
        headers: {
          CompanyID: userData.Data.CompanyID,
          AccessToken: userData.Data.AccessToken,
        },
      })
      .then((response) => {
        console.log("API Response:", response.data);
        setEvaluationData(response.data.Data);
      })
      .catch((error) => {
        console.error("Error fetching evaluation data:", error);
      });
  }, [open]);

  const handleCheckboxChange = (note) => {
    setSelectedNotes((prev) =>
      prev.includes(note)
        ? prev.filter((item) => item !== note)
        : [...prev, note]
    );
  };

  const handleSubmit = () => {
    console.log("Selected Notes:", selectedNotes);
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80%",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Typography variant="h5" mb={2} fontWeight="bold">
          Evaluation Criteria
        </Typography>

        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="h6" fontWeight="bold">
              Critical
            </Typography>
            {evaluationData
              .filter((item) => item.IsCretical)
              .map((item) => (
                <FormControlLabel
                  key={item.Serial}
                  control={
                    <Checkbox
                      checked={selectedNotes.includes(item.Notes)}
                      onChange={() => handleCheckboxChange(item.Notes)}
                    />
                  }
                  label={item.Notes}
                  sx={{ display: "block" }}
                />
              ))}
          </Grid>

          <Grid item xs={6}>
            <Typography variant="h6" fontWeight="bold">
              Non-Critical
            </Typography>
            {evaluationData
              .filter((item) => !item.IsCretical)
              .map((item) => (
                <FormControlLabel
                  key={item.Serial}
                  control={
                    <Checkbox
                      checked={selectedNotes.includes(item.Notes)}
                      onChange={() => handleCheckboxChange(item.Notes)}
                    />
                  }
                  label={item.Notes}
                  sx={{ display: "block" }}
                />
              ))}
          </Grid>
        </Grid>

        <Box mt={3} display="flex" justifyContent="space-between">
          <Button variant="contained" color="error" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
